/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { SlimContactCardsSectionFragment } from "@cosmos/hygraph-schema";
import {
	SlimContactCard,
	ResponsiveContainer,
	SectionContainer,
	SectionHeading,
	BackgroundContainer,
} from "@components/elements";
import { VStack } from "@panda/jsx";
import { css, cx } from "@panda/css";

export const SlimContactCardsSection = ({
	config,
	cards,
	forceShowPaddingTop,
	forceShowPaddingBottom,
}: SlimContactCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(cards?.length);
	if (!validHeading && !validContent) return null;

	const disablePaddingBlock = !validHeading && cards?.length === 1;
	const disablePaddingBlockStart = disablePaddingBlock && !forceShowPaddingTop;
	const disablePaddingBlockEnd = disablePaddingBlock && !forceShowPaddingBottom;

	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer
					disablePaddingBlockStart={disablePaddingBlockStart}
					disablePaddingBlockEnd={disablePaddingBlockEnd}
				>
					<VStack
						alignItems="stretch"
						gap="eds.dimension.96"
						className={cx(
							"slim-contact-cards-section",
							css({
								mdDown: {
									gap: "eds.dimension.80",
								},
							}),
						)}
					>
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<VStack
								alignItems="stretch"
								gap="eds.dimension.40"
								className={cx(
									"slim-contact-cards-stack",
									css({
										"&&": {
											mdDown: {
												gap: "eds.dimension.24",
											},
										},
									}),
								)}
							>
								{cards?.map((card, i) => (
									<SlimContactCard key={`card-${i}`} {...card} />
								))}
							</VStack>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
